import cn from 'classnames';
import Image from 'next/image';

const IconList = ({ list }) => (
  <ul className="space-y-4 lg:space-y-8">
    {list.map(({ text, icon }) => (
      <li className="flex flex-row justify-start text-lg text-neutral-400" key={text}>
        <span className="flex items-center mr-3">
          <Image src={icon?.src} width="24" height="24" alt={icon?.alt} />
        </span>{' '}
        {text}
      </li>
    ))}
  </ul>
);

const DataInputs = ({ type, dataInputSection = [] }) => (
  <div className="grid lg:grid-cols-3">
    {Object.values(dataInputSection)?.map((dataInputList, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div className="flex flex-col space-y-8 justify-between" key={index}>
        {Object.values(dataInputList).map(dataInput =>
          dataInput.label ? (
            <div
              key={dataInput.label}
              className={cn(
                'flex flex-col',
                type === 'common' ? 'lg:flex-row lg:space-x-16' : 'space-y-4'
              )}
            >
              <p
                className={cn(type === 'common' ? 'text-7xl' : 'text-3xl', dataInput.sectionColor)}
              >
                {dataInput.label}
              </p>
              <div className="mt-6 lg:mt-3">
                <IconList list={dataInput.dataInputs} />
              </div>
            </div>
          ) : (
            <div className="lg:block hidden" />
          )
        )}
      </div>
    ))}
  </div>
);

export default DataInputs;
